import React, { useEffect } from "react";
import { useRecoilState } from 'recoil';
import PropTypes from "prop-types";
import {
	baseLatState,
	baseLngState,
	baseIdState,
	effectiveUtilizationState,
	googleApiKeyState,
	timezoneState,
	urlItinerariesState,
	userIDState, calendarViewState,
} from "../recoil/atoms"
import Gmaps from "./Gmaps";
import Calendar from "./Calendar";

const RouteApp = ( { props } ) => {
	const [ userID, setUserID ] = useRecoilState( userIDState );
	const [ googleApiKey, setGoogleApiKey ] = useRecoilState( googleApiKeyState );
	const [ baseLng, setBaseLng ] = useRecoilState( baseLngState );
	const [ baseLat, setBaseLat ] = useRecoilState( baseLatState );
	const [ basePlaceId, setBasePlaceId ] = useRecoilState( baseIdState );
	const [ effectiveUtilization, setEffectiveUtilization ] = useRecoilState( effectiveUtilizationState );
	const [ timezone, setTimezone ] = useRecoilState( timezoneState );
	const [ urlItineraries, setUrlItineraries] = useRecoilState( urlItinerariesState );
	const [ calendarView, setCalendarView ] = useRecoilState( calendarViewState );

	useEffect( () => {
		setUserID( props.userId );
		setBaseLat( props.baseLat );
		setBaseLng( props.baseLng );
		setBasePlaceId( props.basePlaceId );
		setGoogleApiKey( props.googleApiKey );
		setEffectiveUtilization( props.effectiveUtilization );
		setTimezone( props.timezone );
		setUrlItineraries( props.url );
	}, [ props ] )

	return (
		<React.Fragment>
			<div className="row" style={{height: "785px", marginBottom: "15px"}}>
				<div className={"col-xl-7" }>
					<Calendar />
				</div>
				<div className={"col-xl-5 map-container"}>
					<Gmaps />
				</div>
			</div>
		</React.Fragment>
	)
};
RouteApp.propTypes = {
	greeting: PropTypes.string,
	baseLat: PropTypes.string,
	baseLng: PropTypes.string,
	basePlaceId: PropTypes.string,
	userId: PropTypes.string,
	googleApiKey: PropTypes.string,
	effectiveUtilization: PropTypes.number,
	timezone: PropTypes.string,
	urlItineraries: PropTypes.string,
};


export default RouteApp;
